import React, { useState, useEffect } from "react";
import { processRequestForReassign } from "../../redux/actions/actionAction/ActionAction";

import "bootstrap/dist/css/bootstrap.css";
import Modal from "react-bootstrap/Modal";
import * as constantMessages from "../../constants/constatntMessages";
import { checkCharacterLeft } from "../../helpers/commonHelpers";
import { textBoxStrLength } from "../../config/config";
import { useSelector, useDispatch } from "react-redux";
import SmallLoaderButton from "../Common/SmallLoaderButton";

const regularExpressionForAgendaTitle =
  /^[0-9a-zA-Z .,:\n;%@&#!$^*+=()/_'"\\\-?|{}\[\]]+$/;
const RequestForReassignModal = React.memo((props) => {
  const accessToken = localStorage.getItem("accessToken");
  const [reason, setReason] = useState("");
  const [errors, setErrors] = useState({});
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [actionId, setActionId] = useState(null);
  const actionData = useSelector((state) => state.action);
  const dispatch = useDispatch();
  const [loading, setLoading] = useState(false);
  useEffect(() => {
    return () => {
      setReason("");
    };
  }, []);

  useEffect(() => {
    if (actionData.isSuccess) {
      // setReason("");
    }
  }, [actionData.isSuccess]);


  const handleSubmit = async () => {
    // alert("INDNND")
    const newErrors = validateForm();
    setErrors(newErrors);
    if (Object.keys(newErrors).length === 0) {
      setLoading(true);
      const response = await dispatch(
        processRequestForReassign(
          props.actionId,
          {
            requestDetails: reason,
          },
          accessToken
        )
      );


      if (response.success === true) {
      
        setIsModalOpen(false);
        setLoading(false);
      } else {
        setIsModalOpen(true);
      }

      setActionId(null);
    }
  };

  const validateForm = () => {
    const errors = {};
    if (!reason.trim()) {
      errors.reason = constantMessages.largeStringLengthError;
    } else if (!regularExpressionForAgendaTitle.test(reason)) {
      errors.reason = constantMessages.titleRegexError;
    } else if (reason.trim().length < 3 || reason.trim().length > 500) {
      errors.reason = constantMessages.largeStringLengthError;
    }
    setErrors(errors);
    return errors;
  };

  const closeModal = () => {
    setReason("");
    setErrors({});
    props.setIsModalOpen(false);
  };

  const updateValues = (e) => {
    const { name, value } = e.target;
    if (value.length <= textBoxStrLength) {
      setReason(value);
    }
  };

  return (
    <>
      <Modal show={props.isModalOpen} onHide={closeModal} backdrop="static">
        <div className="modal-header">
          <h4 className="modal-title">Request for Forward</h4>

          <button
            type="button"
            className="btn-close"
            aria-label="Close"
            onClick={closeModal}
          ></button>
        </div>
        <div className="modal-body delete-txt">
          <label className="mb-1">
            Reason
            <span className="star-mark">*</span>
          </label>
          <textarea
            cols="40"
            rows="4"
            id="remark"
            name="remark"
            onBlur={validateForm}
            onChange={updateValues}
            value={reason}
            required
          ></textarea>
          <p className="success-message">
            {checkCharacterLeft(reason)} Characters left
          </p>
          {errors.reason && (
            <span className="error-message">{errors.reason}</span>
          )}
        </div>

        <div className="modal-footer">
        

          {loading ? (
            <SmallLoaderButton />
          ) : (
            <button
              type="button"
              onClick={handleSubmit}
              className="Mom-btn btn btn-secondary bg-primary border-primary"
            >
              <p>Submit Request</p>
            </button>
          )}
        </div>
      </Modal>
    </>
  );
});

export default RequestForReassignModal;
